import axios from 'axios'
import moment from 'moment/moment'

const state = {
  runtimeQueueCount: 0,
  blockedIP: [],
  tulipMaintenance: false,
  blockSupport: true,
  userSessions: [],
  taskCountReport: [],
  camundaUserCount: 0
}

const mutations = {
  setRuntimeQueueCount(state, runtimeQueueCount) {
    state.runtimeQueueCount = runtimeQueueCount
  },
  setBlockedIP(state, blockedIP) {
    state.blockedIP = blockedIP
  },

  setTulipMaintenance(state, tulipMaintenance) {
    state.tulipMaintenance = tulipMaintenance
  },

  setBlockSupport(state, blockSupport) {
    state.blockSupport = blockSupport
  },

  setUserSessions(state, userSessions) {
    state.userSessions = userSessions
  },

  setTaskCountReport(state, taskCountReport) {
    state.taskCountReport = taskCountReport
  },

  setCamundaUserCount(state, camundaUserCount) {
    state.camundaUserCount = camundaUserCount
  }
}
const actions = {
  // eslint-disable-next-line no-unused-vars
  async cleanUpRuntimeQueues({ commit }) {
    return axios.post('/api/core/queue/cleanup')
  },

  async cleanDMSCache({ commit }) {
    return axios.delete('/api/core/dms/cache/cleanse')
  },

  async maintainKPIs({ commit }) {
    return axios.post('/api/core/maintain/kpi')
  },
  async deleteDuplicateProfiles({ commit }) {
    return axios.delete('/api/core/profiles/duplicates')
  },
  async fetchRuntimeQueueCount({ commit }) {
    let response = await axios.get('/api/core/queue/count')
    commit('setRuntimeQueueCount', response.data)
  },

  async fetchBlockedIP({ commit }) {
    let response = await axios.get('/api/core/maintain/clients/blocked')
    commit('setBlockedIP', response.data)
  },
  async unBlockIP({ commit }, ip) {
    let response = await axios.post(`/api/core/maintain/release/${ip}`)
    commit('setBlockedIP', response.data)
  },

  async setTulipUnderMaintenance(context, data) {
    let response = await axios.post(
      `/api/core/maintain/under-maintenance/${data.value}`
    )
    return response.data
  },

  async setSupportUserBlock(context, data) {
    let response = await axios.post(
      `/api/core/maintain/block-support/${data.value}`
    )
    return response.data
  },

  async getTulipUnderMaintenance({ commit }) {
    let response = await axios.get(`/api/core/maintain/under-maintenance`)
    commit('setTulipMaintenance', response.data)
  },

  async getBlockedSupport({ commit }) {
    let response = await axios.get(`/api/core/maintain/block-support`)
    commit('setBlockSupport', response.data)
  },

  async fetchTaskCountReport({ commit }, params) {
    if (!params) {
      params = {}
      params.firstResult = 0
      params.maxResults = 10
      params.sortOrder = 'asc'
    }
    let urlParams = `?firstResult=${params.firstResult ||
      0}&maxResults=${params.maxResults || 10}&sortBy=userId&sortOrder=${
      params.sortOrder
    }`
    if (params.firstNameLike) {
      urlParams += `&firstNameLike=${params.firstNameLike}`
    }

    let response = await axios.get(`/api/core/tasks/sync-report${urlParams}`)
    commit('setTaskCountReport', [...response.data.users])
    commit('setCamundaUserCount', response.data.total)
  },

  async syncTaskInBeekeeper(context, assignee) {
    let response = await axios.post(`/api/core/tasks/sync/${assignee}`)
    return response.data
  },

  async syncAllTaskInBeekeeper(context) {
    let response = await axios.post(`/api/core/tasks/sync`)
    return response.data
  },

  async updateTaskDimensions(context, assignee) {
    let response = await axios.post(
      `/api/v1/userTasks/updateDimensions?status=assignment&assignee=${assignee}`
    )
    return response.data
  },

  async updateAllTasksDimensions(context) {
    let response = await axios.post(
      `/api/v1/userTasks/updateDimensions?status=assignment`
    )
    return response.data
  },

  async replicateTaskFromEngine(context, assignee) {
    let response = await axios.post(
      `/api/core/tasks/sync/engine/replicate-for/${assignee}`
    )
    return response.data
  },

  async replicateAllTasksFromEngine(context) {
    let response = await axios.post('/api/core/tasks/sync/engine/replicate')
    return response.data
  },

  async getUserSessions({ commit }) {
    let response = await axios.get('/api/core/maintain/sessions')
    let data = response.data
    data = data.map(item => {
      item.startedAtLocal = moment(item.startedAt)
        .utc()
        .local()
        .format('DD MMM YYYY hh:mm:ss a')
      return item
    })

    commit('setUserSessions', data)
  },
  async killAllSession() {
    let response = await axios.post('/api/core/maintain/kill-all-session')
    return response.data
  }
}

export default {
  state,
  mutations,
  actions
}
